import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache: true
};
const noCacheMeta = {
    auth: false,
    cache:false
};

export default {
    path: '/pcn/',
    name: 'pcn',
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/pcn/pcnRecordTable',
            name: 'pcnRecordTable',
            meta: {
                auth: false,
                cache: true,
                title: 'PCN申请记录一览',
                desc: 'PCN申请记录一览'
            },
            component: () => import('@/pages/pcn/pcnRecordTable.vue')
        },
        {
            path: '/pcn/pcnRegularReport',
            name: 'pcnRegularReport',
            meta: {
                auth: false,
                cache: true,
                title: '变化点定期申报一览',
                desc: '变化点定期申报一览'
            },
            component: () => import('@/pages/pcn/pcnRegularReportTable.vue')
        },
        {
            path: '/pcn/pcnPeriodicFilingStatisticsSummary',
            name: 'pcnPeriodicFilingStatisticsSummary',
            meta: {
                auth: false,
                cache: true,
                title: '变化点定期申报统计',
                desc: '变化点定期申报统计'
            },
            component: () => import('@/pages/pcn/pcnPeriodicFilingStatisticsSummary.vue')
        },
        {
            path: '/pcn/pcnStatisticalSummary',
            name: 'pcnStatisticalSummary',
            meta: {
                ...meta,
                title: '工序变更申请统计',
                desc: '工序变更申请统计',

            },
            component: () => import('@/pages/pcn/pcnStatisticalSummary.vue')
        },
        {
            path: '/pcn/pcnSysEmailConfig',
            name: 'pcnSysEmailConfig',
            meta: {
                ...meta,
                title: '工序变更邮件模板管理',
                desc: '邮件模板管理',
            },
            component: () => import('@/pages/pcn/pcnSysEmailConfig.vue')
        },
        {
            path: '/pcn/pcnSupplierRelation',
            name: 'pcnSupplierRelation',
            meta: {
                ...meta,
                title: '外协厂与工厂关系一览',
                desc: '外协厂与工厂关系一览',
            },
            component: () => import('@/pages/pcn/pcnSupplierRelation.vue')
        },
    ]
}
